import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class AppointmentWindow extends Component {
  static propTypes = {
    appointment: PropTypes.bool,
    window_start: PropTypes.instanceOf(moment),
    window_end: PropTypes.instanceOf(moment),
    status: PropTypes.object,
    onWindowStartChange: PropTypes.func.isRequired,
    onWindowEndChange: PropTypes.func.isRequired,
    onAppointmentChange: PropTypes.func.isRequired,
    onEnableAppointmentTimes: PropTypes.func.isRequired,
  };

  getValidationClass(field) {
    const { status } = this.props;

    if (field === 'all') {
      return {
        error: status.window_start || status.window_end,
      };
    }

    return {
      error: status[field],
    };
  }

  handleSameDayWindowChange = (momentDateObj) => {
    if (!momentDateObj) {
      this.props.onAppointmentChange({
        window_start: null,
        window_end: null,
        appointment: false,
      });
      return;
    }
    const window_start = momentDateObj.startOf('day').toISOString();
    const window_end = momentDateObj.endOf('day').toISOString();

    this.props.onAppointmentChange({
      window_start,
      window_end,
      appointment: false,
    });
  };

  handleWindowStartChange = (momentDateObj) =>
    this.props.onWindowStartChange(getDateValue(momentDateObj));

  handleWindowEndChange = (momentDateObj) =>
    this.props.onWindowEndChange(getDateValue(momentDateObj));

  handleEnableAppointmentTimes = () => this.props.onEnableAppointmentTimes();

  renderSameDayWindow() {
    const { t } = this.props;
    const className = classnames({
      flex: true,
      'items-center': true,
      ...this.getValidationClass('all'),
    });
    return (
      <div className={className}>
        <div className="mr-2">
          <DatePicker
            selected={this.props.window_start}
            className="form-field w-full"
            onChange={this.handleSameDayWindowChange}
            placeholderText={t('ENTER_A_DATE')}
            isClearable
          />
        </div>
        <button
          type="button"
          title={t('ADD_APPOINTMENT')}
          onClick={this.handleEnableAppointmentTimes}
          className="flex items-center"
        >
          <i className="fa fa-plus-circle mr-1 text-grey-darker" />
          <small className="text-xs text-grey-darker">
            {titleize(t('APPOINTMENT'))}
          </small>
        </button>
      </div>
    );
  }

  renderSeparateDayWindows() {
    const windowStartClass = classnames({
      'datepicker-wrapper': true,
      'mr-2': true,
      ...this.getValidationClass('window_start'),
    });

    const windowEndClass = classnames({
      'datepicker-wrapper': true,
      ...this.getValidationClass('window_end'),
    });
    const { t } = this.props;
    return (
      <div className="flex items-center">
        <div className={windowStartClass}>
          <DatePicker
            selected={this.props.window_start}
            className="form-field w-full"
            placeholderText={t('ENTER_START_OF_WINDOW')}
            showTimeSelect
            dateFormat="L LT"
            timeIntervals={30}
            timeCaption={t('WINDOW_TIME')}
            isClearable
            onChange={this.handleWindowStartChange}
            onSelect={this.handleWindowStartChange}
          />
        </div>
        <div className={windowEndClass}>
          <DatePicker
            selected={this.props.window_end}
            className="form-field w-full"
            placeholderText={t('ENTER_END_OF_WINDOW')}
            showTimeSelect
            dateFormat="L LT"
            timeIntervals={30}
            timeCaption={t('WINDOW_TIME')}
            isClearable
            onChange={this.handleWindowEndChange}
            onSelect={this.handleWindowEndChange}
          />
        </div>
      </div>
    );
  }

  render() {
    if (this.props.appointment) {
      return this.renderSeparateDayWindows();
    }
    return this.renderSameDayWindow();
  }
}

function getDateValue(momentDateObj) {
  if (momentDateObj) {
    return momentDateObj.toISOString();
  }
  return null;
}

export default withTranslation()(AppointmentWindow);
